module.exports = __webpack_public_path__ + "img/3-design-and-implement-solutions-1.d8ea3f87.png";